import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3, Boxes } from 'lucide-react';
import { AiUsageStatsView, WeaviateSyncTab } from './components';

export const Route = createFileRoute('/admin-console/ai/statistics')({
    staticData: {
        breadcrumb: {
            title: 'Platform statistics',
        },
        ui: {
            icon: BarChart3,
            title: 'AI statistics',
            subtitle: 'Monitor AI token usage and costs across organisations and users.',
            widthVariant: 'default',
            menuDescription: 'View AI usage statistics',
        },
    },
    component: AIStatistics,
});

function AIStatistics() {
    return (
        <PageController route={Route}>
            <AiUsageStatsView
                extraTabs={({ period }) => [
                    {
                        key: 'weaviateSync',
                        label: (
                            <span className="flex items-center gap-2">
                                <Boxes className="h-4 w-4" />
                                Weaviate sync
                            </span>
                        ),
                        children: <WeaviateSyncTab period={period} />,
                    },
                ]}
            />
        </PageController>
    );
}
